import { createSlice } from '@reduxjs/toolkit';
import { AvailableShiftModel, GetAvailableShiftsResponse } from 'api/ShiftWizardApi';
import { getAvailableShifts, requestShift } from 'thunks';

export interface ShiftWizardData {
  shifts: AvailableShiftModel[];
  isLoading: boolean;
  isCompleted: boolean;
  isError: boolean;
  isShiftRequested: boolean;
}

const initialState: ShiftWizardData = {
  shifts: [],
  isLoading: false,
  isCompleted: false,
  isError: false,
  isShiftRequested: false,
};

const shiftWizard = createSlice({
  name: 'shiftWizard',
  initialState,
  reducers: {
    clearShifts: (state) => {
      state.shifts = [];
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    const handlePending = (state: ShiftWizardData) => {
      state.isLoading = true;
      state.isCompleted = false;
      state.isError = false;
    };

    const handleFulfilled = (state: ShiftWizardData, payload: GetAvailableShiftsResponse) => {
      state.isLoading = false;
      state.isCompleted = true;
      state.shifts = payload;
    };

    const handleRejected = (state: ShiftWizardData) => {
      state.isLoading = false;
      state.isCompleted = true;
      state.isError = true;
    };

    builder.addCase(getAvailableShifts.pending, handlePending);
    builder.addCase(getAvailableShifts.fulfilled, (state, { payload }) => handleFulfilled(state, payload));
    builder.addCase(getAvailableShifts.rejected, handleRejected);
    builder.addCase(requestShift.fulfilled, (state) => {
      state.isShiftRequested = true;
    });
  },
});

export const { clearShifts } = shiftWizard.actions;

export default shiftWizard.reducer;
